import React, { useState, useEffect } from "react";
import UserPanel from "@/Components/PageTop/UserPanel";
import HomeLogo from "@/assets/loginLogo.svg";
import { getQueryString, replaceFormulaStr } from "@/config/func";
import { useNavigate } from "react-router-dom";
import materials from "./material.json";
import params from "./parameters.json";
import ModelViewer from "@/Components/3DViewer";
import { get_properties_from_cas } from "@/services/propsApi";


const specials: any = [
  "KLDIP",
  "KVDIP",
  "CPIGDP",
  "CPSDIP",
  "DHVLDP",
  "DNLDIP",
  "DNSDIP",
  "MULDIP",
  "MUVDIP",
  "PLXANT",
  "PSXANT",
  "SIGDIP",
  "VLBROC",
  "WATSOL",
  // "VLSTD",
];

const Component = (props: any) => {
  const [source, setSource] = useState<any>(null);
  const history = useNavigate();
  const [query, setQuery] = useState<any>(null);
  const [curParam, setCurParam] = useState<any>(null);

  const getMaterial = (key: any) => {
    if (key) {
      const item: any = materials.find(
        (m: any) =>
          m.cname === key ||
          m.cas_code === key ||
          m.name === key ||
          m.component === key ||
          m.alias === key
      );
      return item;
    } else {
      return null;
    }
  };

  useEffect(() => {


    const k = getQueryString("key") ? getQueryString("key") : "氢气";
    setQuery(k);
    const i: any = getMaterial(k);
    console.log("kkkkk", k);
    console.log("iiii", i);
    setSource(i);
  }, [getQueryString("key")]);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      history(`/info?key=${query}`);
      window.location.reload();
    }
  };

  const getparams = () => {
    if (source) {
      const { properties } = source;
      return (
        <ul className="paramsList">
          {Object.keys(properties).map((key: any) => {
            const item: any = params.find((p: any) => p.title === key);
            if (item) {
              return (
                <li
                  key={key}
                  onClick={() => setCurParam(key)}
                  className={curParam === key ? "active" : ""}
                >
                  <span>{curParam === key ? "●" : "○"}</span>
                  {item.name}
                  {/* ({key}) {item.units} */}
                </li>
              );
            }
          })}
        </ul>
      );
    } else {
      return null;
    }
  };

  const getItenGrid = (
    key: any,
    title: any,
    unit: any = "",
    value: any = null,
    length: any = false
  ) => {
    let v = value;
    if (v === null) {
      v = source.properties[key];
    }
    return (
      <div className={`gridItem${curParam === key ? " active" : ""}`}>
        <div className="gridItemName">
          <b>◥</b>
          {title}：
        </div>
        <div className="gridItemValue">
          {length ? Number(v.toFixed(length)) : v}
          {/* {length ? source.properties[key].toFixed(length) : source.properties[key]} */}
        </div>
        <div className="gridItemUnit">{unit}</div>
      </div>
    );
  };

  const getItem = (key: any) => {
    const item: any = params.find((i: any) => i.title === key);
    return item;
  };

  return (
    <div className="mainPage">
      <div className="pTop2">
        {/* <div></div> */}
        <div className="homeLg">
          <img
            src={HomeLogo}
            alt=""
            style={{ cursor: "pointer", height: "23px", marginRight: "2rem" }}
            onClick={() => history("/")}
          />
          <input
            type="text"
            className="topSearch"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <UserPanel />
      </div>
      {source ? (
        <div className="mainContent">
          <div className="pageMainContent">
            <div className="p_left">
              <div className="l_line">
                <div className="l_line_l">
                  <ModelViewer
                    filePath={`/f/${source.cname}.sdf`}
                    height="300px"
                    width="100%"
                    // disLenged={true}
                    bgColor="rgba(2, 77, 196,0.03)"
                    pngImg={`/f/${source.cname}.svg`}
                    // refresh={false}
                  />
                </div>
                <div className="l_line_r">
                  <div className="r_i">
                    <ul className="itemList">
                      <li>
                        <div className="itemName">中文名称：</div>
                        <div className="itemValue">{source.cname}</div>
                      </li>
                      <li>
                        <div className="itemName">英文名称：</div>
                        <div className="itemValue">{source.name}</div>
                      </li>
                      <li>
                        <div className="itemName">分子式：</div>
                        <div className="itemValue">{replaceFormulaStr(source.component)}</div>
                      </li>
                      <li>
                        <div className="itemName">CAS号：</div>
                        <div className="itemValue">{source.cas_code}</div>
                      </li>
                      <li>
                        <div className="itemName">物质分类：</div>
                        <div className="itemValue">{source.category}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="r_i">
                    <ul className="itemList">
                      <li className={`${curParam === "MW" ? " active" : ""}`}>
                        <div className="itemName">
                          <b>◥</b>分子量：
                        </div>
                        <div className="itemValueNum">{source.properties.MW}</div>
                      </li>
                      <li className={`${curParam === "SG" ? " active" : ""}`}>
                        <div className="itemName">
                          <b>◥</b>比重：
                        </div>
                        <div className="itemValueNum">{source.properties.SG}</div>
                      </li>
                      <li className={`${curParam === "API" ? " active" : ""}`}>
                        <div className="itemName">
                          <b>◥</b>API比重：
                        </div>
                        <div className="itemValueNum">{source.properties.API}</div>
                      </li>
                      <li className={`${curParam === "CHARGE" ? " active" : ""}`}>
                        <div className="itemName">
                          <b>◥</b>电荷数：
                        </div>
                        <div className="itemValueNum">{source.properties.CHARGE}</div>
                      </li>
                      <li className={`${curParam === "OMEGA" ? " active" : ""}`}>
                        <div className="itemName">
                          <b>◥</b>偏心因子：
                        </div>
                        <div className="itemValueNum">{source.properties.OMEGA}</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="l_line_2 mt2">
                <div className="gridContent4">
                  {getItenGrid("PC", "临界压力", "bar")}
                  {getItenGrid("TC", "临界温度", "C")}
                  {getItenGrid("TB", "常压泡点", "C")}
                  {getItenGrid("VC", "临界体积密度", "cc/mol")}
                  {getItenGrid("ZC", "临界压缩因子")}
                  {getItenGrid("MUP", "粘度压力校正", "debye")}
                  {getItenGrid("TPT", "三相点温度", "C")}
                  {getItenGrid("HFUS", "熔点熔化焓", "cal/mol", 3)}
                </div>
              </div>

              <div className="l_line_2 mt2">
                <div className="gridContent3">
                  {specials.map((key: any, ki: any) => {
                    return (
                      <>
                        {getItem(key)
                          ? source.properties[key]
                            ? getItenGrid(
                                key,
                                getItem(key).name,
                                getItem(key).units,
                                source.properties[key][0],
                                3
                              )
                            : ""
                          : ""}
                      </>
                    );
                  })}
                </div>
              </div>

              <div className="l_line_2 mt2">
                <div className="gridContent2">
                  {getItenGrid("DGFORM", "298.15K,1atm理想气体吉布斯自由能", "cal/mol")}
                  {getItenGrid("DHAQFM", "298.15K,1atm水相标准生成焓", "cal/mol")}
                  {getItenGrid("DHFORM", "298.15K,1atm理想气体焓", "cal/mol")}
                  {getItenGrid("S025E", "25℃化合物组成元素绝对熵总和", "cal/mol-K")}
                  {getItenGrid("VB", "常压沸点液相摩尔体积", "cc/mol")}
                  {getItenGrid("HCOM", "298.15K,1atm燃烧热", "cal/mol")}
                  {getItenGrid("RKTZRA", "液体摩尔体积模型中的Rackett方程参数")}
                  {getItenGrid("DHVLB", "常压沸点汽化热", "cal/mol", 3)}
                </div>
              </div>
              
            </div>
            <div className="p_right">{getparams()}</div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Component;
